import { all, fork, put, select, takeLatest } from 'redux-saga/effects';
import { RedeemMethodEnum, OPTION_TAB } from '../../../constant/marketplace';
import {
  setTab,
  setPrevTab,
  getRetailersApi,
  getCategoriesApi,
  getCountriesApi,
  ACTION_POST_IMAGE,
  postImageAPI,
  getMarketplaceItemsAPI,
  ACTION_CREATE_MARKETPLACE_ITEM,
  createMarketplaceItemAPI,
  getCountriesAPI,
  getCategoriesAPI,
  REQUEST_CREATE_MARKETPLACE_ITEM_SUCCESS,
  REQUEST_CREATE_MARKETPLACE_ITEM_FAILURE,
  ACTION_GET_COUNTRIES,
  REQUEST_POST_IMAGE_FAILURE,
  REQUEST_POST_IMAGE_SUCCESS,
  ACTION_GET_CATEGORIES,
  REQUEST_GET_COUNTRIES_SUCCESS,
  REQUEST_GET_COUNTRIES_FAILURE,
  REQUEST_GET_CATEGORIES_SUCCESS,
  REQUEST_GET_CATEGORIES_FAILURE,
  showToastAlert,
  REQUEST_BUY_REDEEM_FAILURE,
  REQUEST_BUY_REDEEM_SUCCESS,
  ACTION_GET_MARKETPLACE_ITEM,
  getMarketplaceItemAPI,
  REQUEST_MARKETPLACE_ITEM_SUCCESS,
  ACTION_POST_CONFIRM_DELIVERY,
  confirmDeli,
  REQUEST_CONFIRM_DELIVERY_SUCCESS,
  REQUEST_CONFIRM_DELIVERY_FAILURE,
  reportItemAPI,
  ACTION_POST_REPORT_MARKETPLACE_ITEM,
  REQUEST_REPORT_MARKETPLACE_ITEM_SUCCESS,
  REQUEST_REPORT_MARKETPLACE_ITEM_FAILURE,
  setItemToReport,
} from './index';
import { getProfilesAPI } from '../profile';
import { fetchUserInfo } from '../auth';
import { getAuthToken } from '../../../utils/localStorage';
import { getErrorMessage } from '../../../utils/error';

function* loadMarketplaceData() {
  const { marketplace } = yield select();
  const { marketplaceFilter } = marketplace;
  yield put(getCategoriesAPI(marketplaceFilter));
  yield put(getCountriesAPI(marketplaceFilter));
}
function* loadProfileData() {
  const { profile } = yield select();
  const { profileFilter } = profile;
  yield put(getProfilesAPI(profileFilter));
}
function* loadRouteData() {
  const { marketplace } = yield select();
  const { retailerFilter, marketplaceItemsFilter, categoriesFilter, countriesFilter } = marketplace;
  yield put(getRetailersApi(retailerFilter));
  yield put(getMarketplaceItemsAPI(marketplaceItemsFilter));
  yield put(getCategoriesApi(categoriesFilter));
  yield put(getCountriesApi(countriesFilter));
}
function* handleCreateRedeem() {
  yield takeLatest([REQUEST_BUY_REDEEM_FAILURE], function* (action) {
    const { marketplace } = yield select();
    const { error, currentTab, prevTab } = marketplace;
    yield put(showToastAlert(action?.payload?.data?.message || 'Failed !', 'error'));
    console.log(currentTab + ' - ' + prevTab);
    console.log('Failed to buy redeem', error);
  });

  yield takeLatest([REQUEST_BUY_REDEEM_SUCCESS], function* (action) {
    const { marketplace } = yield select();

    const { offer } = marketplace;
    yield put(showToastAlert(action?.payload?.data?.message || 'Successful', 'success'));

    const token = getAuthToken();
    yield put(fetchUserInfo(token));

    const redeemMethod = offer?.item?.promotion?.redeemMethod;
    switch (redeemMethod) {
      case RedeemMethodEnum.PROMO_CODE:
        yield put(setTab(OPTION_TAB.userMarketPromoCodeTab));
        yield put(setPrevTab(OPTION_TAB.userMarketSelectTab));
        break;
      case RedeemMethodEnum.FREE_ITEM_DELIVERED:
        yield put(setTab(OPTION_TAB.userMarketProductDeliveredTab));
        yield put(setPrevTab(OPTION_TAB.userMarketSelectTab));
        break;
      case RedeemMethodEnum.QR_CODE:
        yield put(setTab(OPTION_TAB.userMarketQRCodeTab));
        yield put(setPrevTab(OPTION_TAB.userMarketSelectTab));
        break;
      default:
        break;
    }
  });
}

function* handleGetCategories() {
  yield takeLatest([ACTION_GET_CATEGORIES], function* (action) {
    yield put(getCategoriesAPI(action.payload));
  });
  yield takeLatest([REQUEST_GET_CATEGORIES_SUCCESS], function* () {
    // yield put(showToastAlert('Get Categories Success!', 'success'));
  });
  yield takeLatest([REQUEST_GET_CATEGORIES_FAILURE], function* (action) {
    // yield put(
    //   showToastAlert(
    //     `Failed to get Categories Data. Error:  ${action?.payload?.error?.message}`,
    //     'error'
    //   )
    // );
    yield console.log(`Failed to get Categories Data. Error:  ${action?.payload?.error?.message}`);
  });
}

function* handlePostImage() {
  yield takeLatest([ACTION_POST_IMAGE], function* (action) {
    yield put(postImageAPI(action.payload));
  });
  yield takeLatest([REQUEST_POST_IMAGE_SUCCESS], function* () {
    // yield put(showToastAlert('Get Image Success!', 'success'));
  });
  yield takeLatest([REQUEST_POST_IMAGE_FAILURE], function* (action) {
    yield put(
      showToastAlert(`Failed to Post a Image. Error:  ${action?.payload?.error?.message}`, 'error')
    );
  });
}

export const handleGetMarketplaceItem = function* () {
  yield takeLatest([ACTION_GET_MARKETPLACE_ITEM], function* (action) {
    yield put(getMarketplaceItemAPI(action.payload));
  });
  yield takeLatest([REQUEST_MARKETPLACE_ITEM_SUCCESS], function* () {
    // yield put(showToastAlert('Get Marketplace Item Success!', 'success'));
    yield console.log('Get Marketplace Item Success!');
  });
  yield takeLatest([REQUEST_CREATE_MARKETPLACE_ITEM_FAILURE], function* (action) {
    // yield put(
    //   showToastAlert(
    //     `Failed to get Marketplace Item. Error:  ${action?.payload?.data?.message[0].error}`,
    //     'error'
    //   )
    // );
    yield console.log(
      `Failed to get Marketplace Item. Error:  ${action?.payload?.data?.message[0].error}`
    );
  });
};

export const handleCreateItem = function* () {
  yield takeLatest([ACTION_CREATE_MARKETPLACE_ITEM], function* (action) {
    yield put(createMarketplaceItemAPI(action.payload));
  });
  yield takeLatest([REQUEST_CREATE_MARKETPLACE_ITEM_SUCCESS], function* () {
    window.location.reload();
    yield put(showToastAlert('Create Marketplace Item Success!', 'success'));
  });
  yield takeLatest([REQUEST_CREATE_MARKETPLACE_ITEM_FAILURE], function* (action) {
    yield put(
      showToastAlert(
        "Submission failed. Please don't leave any fields empty and enter valid inputs.",
        'warning'
      )
    );
    yield console.log(
      `Failed to create Marketplace Item. Error:  ${action?.payload?.data?.message[0].error}`
    );
  });
};

export const handleGetCountries = function* () {
  yield takeLatest([ACTION_GET_COUNTRIES], function* (action) {
    yield put(getCountriesAPI(action.payload));
  });
  yield takeLatest([REQUEST_GET_COUNTRIES_SUCCESS], function* () {
    // yield put(showToastAlert('Get Country List Success!', 'success'));
  });
  yield takeLatest([REQUEST_GET_COUNTRIES_FAILURE], function* (action) {
    // yield put(
    //   showToastAlert(
    //     `Failed to get Country List. Error:  ${action?.payload?.error?.message}`,
    //     'error'
    //   )
    // );
    yield console.log(`Failed to get Country List. Error:  ${action?.payload?.error?.message}`);
  });
};

export const handlePostConfirmDelivery = function* () {
  yield takeLatest([ACTION_POST_CONFIRM_DELIVERY], function* (action) {
    yield put(confirmDeli(action.payload));
  });
  yield takeLatest([REQUEST_CONFIRM_DELIVERY_SUCCESS], function* () {
    yield put(showToastAlert('Get Confirm Delivery Details Order Success!', 'success'));
    yield put(setTab(OPTION_TAB.userMarketSummaryTab));
  });
  yield takeLatest([REQUEST_CONFIRM_DELIVERY_FAILURE], function* (action) {
    yield put(showToastAlert(getErrorMessage(action.payload), 'error'));
  });
};

export const handlePostReportItem = function* () {
  yield takeLatest([ACTION_POST_REPORT_MARKETPLACE_ITEM], function* (action) {
    yield put(reportItemAPI(action.payload));
  });
  yield takeLatest([REQUEST_REPORT_MARKETPLACE_ITEM_SUCCESS], function* () {
    yield put(setItemToReport(null));
    yield put(showToastAlert('Report Item Success!', 'success'));
  });
  yield takeLatest([REQUEST_REPORT_MARKETPLACE_ITEM_FAILURE], function* (action) {
    yield put(setItemToReport(null));
    yield put(showToastAlert(getErrorMessage(action.payload), 'error'));
  });
};

export function* loadMarketplacePage() {
  yield all([
    fork(loadMarketplaceData),
    fork(loadProfileData),
    fork(handleGetCountries),
    fork(handleGetCategories),
    fork(handlePostImage),
    fork(loadRouteData),
    fork(handleCreateItem),
    fork(handleCreateRedeem),
    fork(handleGetMarketplaceItem),
    fork(handlePostConfirmDelivery),
    fork(handlePostReportItem),
  ]);
}
